import React from 'react';
import { Box, Notice } from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';

import { useGetRbcGicRate } from '../../data/getRbcGicRate';

const GicRateDisplay = () => {
  const { t } = useTranslation();
  const {
    data: gicRate,
    isFetching: rbcRateIsFetching,
    hasError: rbcRateError,
  } = useGetRbcGicRate();
  if (rbcRateIsFetching) {
    return <div style={{ display: 'none' }}> RBC Rates Loading... </div>;
  }
  if (rbcRateError) {
    return null;
  }
  if (!gicRate || !gicRate.rate) {
    return null;
  }
  return (
    <Box pt={10}>
      <Notice intent="secondary" width="fill">
        <b>{t('rbcv2.rate.rateDescription', { rbcRate: gicRate.rate })}</b>
      </Notice>
      <Box pt={2}>{t('rbcv2.rate.disclaimer')}</Box>
    </Box>
  );
};

export default GicRateDisplay;
